<template>
  <div class="wrapper d-flex flex-column min-vh-100 bg-body">
    <unauthorized-header />
    <main v-show="!pageLoadingStatus" class="container-fluid py-3">
      <router-view />
    </main>
  </div>
</template>

<script>
import UnauthorizedHeader from "@/views/organisms/UnauthorizedHeader";

export default {
  name: 'UnauthorizedLayout',
  components: {
    UnauthorizedHeader,
  },
  computed: {
    pageLoadingStatus() {
      return this.$store.state.pageLoading;
    },
  },
}
</script>
